{
	"commonValues": {
		"Books_Page-settings_Hide-sku": {
			"isCheckbox": true,
			"groupLabel": "Default Attribute Visibility",
			"infoIcon": "Hide certain attributes by default even if they are selected in your display order. This can be toggled off in the Book settings",
			"value": false,
			"label": "Hide SKU by default"
		},
		"Books_Page-settings_Hide-item-code": {
			"isCheckbox": true,
			"value": false,
			"label": "Hide Item Code by default"
		},
		"Books_Page-settings_Hide-manufacturer": {
			"isCheckbox": true,
			"value": false,
			"label": "Hide Manufacturer by default"
		},
		"Books_Page-settings_Ruler-label": {
			"isString": true,
			"labelHeader": "Ruler",
			"isReadOnlyString": true
		},
		"Books_Page-settings_Show-ruler": {
			"isToggle": true,
			"value": true,
			"labelValue": "Show ruler",
			"customClasses": "slds-m-bottom--x-large"
		},
		"Books_Page-settings_Grids-label": {
			"isString": true,
			"labelHeader": "Grids",
			"isReadOnlyString": true
		},
		"Books_Page-settings_Show-grid": {
			"isToggle": true,
			"value": true,
			"labelValue": "Show grid"
		},
		"Books_Page-settings_View-grid": {
			"isToggle": true,
			"value": false,
			"labelValue": "View grid on top"
		},
		"Books_Page-settings_Snap-elements": {
			"isToggle": true,
			"value": false,
			"labelValue": "Snap elements to grid",
			"customClasses": "slds-m-bottom--medium"
		},
		"Books_Page-settings_Grid-size": {
			"isRadio": true,
			"value": 10,
			"label": "Grid size",
			"isBoldLabel": true,
			"customClasses": "slds-m-bottom--medium",
			"isRadioFullWidth": true,
			"options": [
				{
					"value": 10,
					"label": "Small (10 px)"
				},
				{
					"value": 20,
					"label": "Medium (20 px)"
				},
				{
					"value": 40,
					"label": "Large (40 px)"
				}
			]
		},
		"Books_Page-settings_Grid-color-label": {
			"isString": true,
			"labelHeader": "Grid color",
			"isReadOnlyString": true
		},
		"Books_Page-settings_Grid-color": {
			"isColorPicker": true,
			"value": "#E5E5E5",
			"isColorPickerSimplified": true,
			"customClasses": "slds-m-bottom--x-large slds-m-top--x-small"
		},
		"Books_Page-settings_Show-guide-label": {
			"isString": true,
			"labelHeader": "Guide",
			"isReadOnlyString": true
		},
		"Books_Page-settings_Show-guide": {
			"isToggle": true,
			"value": true,
			"labelValue": "Show guides",
			"customClasses": "slds-m-bottom--medium"
		},
		"Books_Page-settings_Guide-color-label": {
			"isString": true,
			"labelHeader": "Guide color",
			"isReadOnlyString": true
		},
		"Books_Page-settings_Guide-color": {
			"isColorPicker": true,
			"value": "#EA2AA9",
			"isColorPickerSimplified": true,
			"customClasses": "slds-m-bottom--medium slds-m-top--x-small"
		},
		"Books_Size_Orientation-Label": {
			"isString": true,
			"labelHeader": "Orientation",
			"isReadOnlyString": true
		},
		"Books_Size_Orientation": {
			"isOrientationToggle": true,
			"value": "Landscape",
			"customClasses": "slds-m-bottom--medium"
		},
		"Books_Size_Default-size": {
			"isRadio": true,
			"value": "Tabloid",
			"label": "Default size",
			"isBoldLabel": true,
			"customClasses": "slds-m-bottom--medium",
			"isRadioFullWidth": true,
			"isRadioForPageSize": true,
			"options": [
				{
					"value": "Tabloid",
					"label": "Tabloid (17” x 11”)"
				},
				{
					"value": "Letter",
					"label": "Letter (11” x 8.5”)"
				},
				{
					"value": "A4",
					"label": "A4"
				},
				{
					"value": "A5",
					"label": "A5"
				},
				{
					"value": "Size16x9",
					"label": "16:9"
				}
			]
		},
		"Plumbing_Accessories_Air_Hand_Hair_Dryer_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 15
		},
		"Plumbing_Accessories_Air_Hand_Hair_Dryer_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 38,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Air_Hand_Hair_Dryer_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 22
		},
		"Plumbing_Accessories_Air_Hand_Hair_Dryer_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 56,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Air_Hand_Hair_Dryer_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 42
		},
		"Plumbing_Accessories_Air_Hand_Hair_Dryer_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 106,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Grab_Bar_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 24
		},
		"Plumbing_Accessories_Grab_Bar_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 60,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Grab_Bar_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 36
		},
		"Plumbing_Accessories_Grab_Bar_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Medicine_Cabinet_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 20
		},
		"Plumbing_Accessories_Medicine_Cabinet_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 50,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Medicine_Cabinet_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 24
		},
		"Plumbing_Accessories_Medicine_Cabinet_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 60,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Medicine_Cabinet_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 36
		},
		"Plumbing_Accessories_Medicine_Cabinet_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Robe_Hook_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 2
		},
		"Plumbing_Accessories_Robe_Hook_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 5,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Robe_Hook_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 2
		},
		"Plumbing_Accessories_Robe_Hook_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 5,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Robe_Hook_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 70
		},
		"Plumbing_Accessories_Robe_Hook_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 177,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Receptacle_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 12
		},
		"Plumbing_Accessories_Receptacle_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 30,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Receptacle_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 25
		},
		"Plumbing_Accessories_Receptacle_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 63,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Receptacle_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 36
		},
		"Plumbing_Accessories_Receptacle_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Shower_Curtain_Rod_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 60
		},
		"Plumbing_Accessories_Shower_Curtain_Rod_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Shower_Curtain_Rod_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 75
		},
		"Plumbing_Accessories_Shower_Curtain_Rod_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 190,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Shower_Storage_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 12
		},
		"Plumbing_Accessories_Shower_Storage_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 30,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Shower_Storage_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 12
		},
		"Plumbing_Accessories_Shower_Storage_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (cm)",
			"value": 30,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Shower_Storage_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 48
		},
		"Plumbing_Accessories_Shower_Storage_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 121,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Toilet_Paper_Holder_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 7
		},
		"Plumbing_Accessories_Toilet_Paper_Holder_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 17,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Toilet_Paper_Holder_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 2
		},
		"Plumbing_Accessories_Toilet_Paper_Holder_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 5,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Toilet_Paper_Holder_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 26
		},
		"Plumbing_Accessories_Toilet_Paper_Holder_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 66,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel_Dispenser_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 11
		},
		"Plumbing_Accessories_Towel_Dispenser_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 27,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel_Dispenser_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 15
		},
		"Plumbing_Accessories_Towel_Dispenser_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 38,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel_Dispenser_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 48
		},
		"Plumbing_Accessories_Towel_Dispenser_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 121,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel_Rack_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 24
		},
		"Plumbing_Accessories_Towel_Rack_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 60,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel_Rack_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 34
		},
		"Plumbing_Accessories_Towel_Rack_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 86,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel_Rack_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 14
		},
		"Plumbing_Accessories_Towel_Rack_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 35,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel_Warmer_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 24
		},
		"Plumbing_Accessories_Towel_Warmer_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 60,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel_Warmer_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 34
		},
		"Plumbing_Accessories_Towel_Warmer_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 86,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel_Warmer_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 14
		},
		"Plumbing_Accessories_Towel_Warmer_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 35,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel-Bars_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 18
		},
		"Plumbing_Accessories_Towel-Bars_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 48
		},
		"Plumbing_Accessories_Towel-Bars_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 45,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel-Bars_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 122
		},
		"Plumbing_Accessories_Towel-Ring_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 6
		},
		"Plumbing_Accessories_Towel-Ring_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel-Ring_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 6
		},
		"Plumbing_Accessories_Towel-Ring_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (Cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Accessories_Towel-Ring_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 52
		},
		"Plumbing_Accessories_Towel-Ring_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (Cm)",
			"value": 132,
			"groupLabel": "Metric"
		},
		"Plumbing_SAccessories_Towel-Ring_Mounted-Measure-Point": {
			"isRadio": true,
			"label": "Measure Point",
			"value": "Mount",
			"options": [
				{
					"value": "Mount",
					"label": "Mount"
				},
				{
					"value": "Head",
					"label": "Head"
				}
			]
		},
		"Plumbing_Shower_Combo_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 60
		},
		"Plumbing_Shower_Combo_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Combo_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 32
		},
		"Plumbing_Shower_Combo_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 81,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Combo_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 72
		},
		"Plumbing_Shower_Combo_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 182,
			"groupLabel": "Metric"
		},
		"Plumbing_Bathtub_Surround_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 60
		},
		"Plumbing_Bathtub_Surround_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Bathtub_Surround_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 32
		},
		"Plumbing_Bathtub_Surround_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 81,
			"groupLabel": "Metric"
		},
		"Plumbing_Bathtub_Surround_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 60
		},
		"Plumbing_Bathtub_Surround_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Stall_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 60
		},
		"Plumbing_Shower_Stall_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Stall_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 36
		},
		"Plumbing_Shower_Stall_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Stall_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 72
		},
		"Plumbing_Shower_Stall_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 182,
			"groupLabel": "Metric"
		},
		"Plumbing_Bathtubs_Exterior-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Exterior Width (in)",
			"value": 60
		},
		"Plumbing_Bathtubs_Exterior-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Exterior Width (cm)",
			"value": 170,
			"groupLabel": "Metric"
		},
		"Plumbing_Bathtubs_Exterior-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Exterior Depth (in)",
			"value": 30
		},
		"Plumbing_Bathtubs_Exterior-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Exterior Depth (cm)",
			"value": 70
		},
		"Plumbing_Bathtubs_Interior-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Interior Width (in)",
			"value": 54
		},
		"Plumbing_Bathtubs_Interior-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Interior Width (cm)",
			"value": 155
		},
		"Plumbing_Bathtubs_Interior-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Interior Depth (in)",
			"value": 24
		},
		"Plumbing_Bathtubs_Interior-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Interior Depth (cm)",
			"value": 55
		},
		"Plumbing_Bathtubs_Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 16
		},
		"Plumbing_Bathtubs_Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 40
		},
		"Plumbing_Bidet_Floor_Mounted_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 15
		},
		"Plumbing_Bidet_Floor_Mounted_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 38,
			"groupLabel": "Metric"
		},
		"Plumbing_Bidet_Floor_Mounted_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 25
		},
		"Plumbing_Bidet_Floor_Mounted_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 63,
			"groupLabel": "Metric"
		},
		"Plumbing_Bidet_Floor_Mounted_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 15
		},
		"Plumbing_Bidet_Floor_Mounted_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 38,
			"groupLabel": "Metric"
		},
		"Plumbing_Bidet_Wall_Mounted_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 15
		},
		"Plumbing_Bidet_Wall_Mounted_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 38,
			"groupLabel": "Metric"
		},
		"Plumbing_Bidet_Wall_Mounted_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 25
		},
		"Plumbing_Bidet_Wall_Mounted_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 63,
			"groupLabel": "Metric"
		},
		"Plumbing_Bidet_Wall_Mounted_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 15
		},
		"Plumbing_Bidet_Wall_Mounted_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 38,
			"groupLabel": "Metric"
		},
		"Plumbing_Bidet_Wall_Mounted_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 5
		},
		"Plumbing_Bidet_Wall_Mounted_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 12,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Oval_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 3.5
		},
		"Plumbing_Body_Spray_Oval_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 9,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Oval_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 11
		},
		"Plumbing_Body_Spray_Oval_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 28,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Oval_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 60
		},
		"Plumbing_Body_Spray_Oval_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Rectangular_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 9.5
		},
		"Plumbing_Body_Spray_Rectangular_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 24,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Rectangular_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 2
		},
		"Plumbing_Body_Spray_Rectangular_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 5,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Rectangular_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 60
		},
		"Plumbing_Body_Spray_Rectangular_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Square_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 3
		},
		"Plumbing_Body_Spray_Square_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 7,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Square_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 3
		},
		"Plumbing_Body_Spray_Square_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 7,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Square_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 60
		},
		"Plumbing_Body_Spray_Square_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Round_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 3
		},
		"Plumbing_Body_Spray_Round_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 7,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Round_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 3
		},
		"Plumbing_Body_Spray_Round_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 7,
			"groupLabel": "Metric"
		},
		"Plumbing_Body_Spray_Round_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 60
		},
		"Plumbing_Body_Spray_Round_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Faucet_Bar_Prep_Sink-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 12
		},
		"Plumbing_Faucet_Bar_Prep_Sink-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default  Height (cm)",
			"value": 30,
			"groupLabel": "Metric"
		},
		"Plumbing_Faucet_Bathtub-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 6
		},
		"Plumbing_Faucet_Bathtub-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default  Height (cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Faucet_Bidet-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 5
		},
		"Plumbing_Faucet_Bidet-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default  Height (cm)",
			"value": 13,
			"groupLabel": "Metric"
		},
		"Plumbing_Faucet_Kitchen_Sink-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 20
		},
		"Plumbing_Faucet_Kitchen_Sink-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default  Height (cm)",
			"value": 50,
			"groupLabel": "Metric"
		},
		"Plumbing_Faucet_Lavatory_Sink-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 8
		},
		"Plumbing_Faucet_Lavatory_Sink-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default  Height (cm)",
			"value": 20,
			"groupLabel": "Metric"
		},
		"Plumbing_Faucet_Pot_Filler-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 8
		},
		"Plumbing_Faucet_Pot_Filler-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default  Height (cm)",
			"value": 20,
			"groupLabel": "Metric"
		},
		"Plumbing_Faucet_Utility_Sink-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 8
		},
		"Plumbing_Faucet_Utility_Sink-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default  Height (cm)",
			"value": 20,
			"groupLabel": "Metric"
		},
		"Plumbing_Faucet_Wall_Dispenser-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 10
		},
		"Plumbing_Faucet_Wall_Dispenser-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default  Height (cm)",
			"value": 25,
			"groupLabel": "Metric"
		},
		"Plumbing_Hand_Shower_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 3
		},
		"Plumbing_Hand_Shower_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 7,
			"groupLabel": "Metric"
		},
		"Plumbing_Hand_Shower_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 9
		},
		"Plumbing_Hand_Shower_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 22,
			"groupLabel": "Metric"
		},
		"Plumbing_Hand_Shower_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 60
		},
		"Plumbing_Hand_Shower_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Hot_Tub_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 84
		},
		"Plumbing_Hot_Tub_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 213,
			"groupLabel": "Metric"
		},
		"Plumbing_Hot_Tub_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 84
		},
		"Plumbing_Hot_Tub_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 213,
			"groupLabel": "Metric"
		},
		"Plumbing_Hot_Tub_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 34
		},
		"Plumbing_Hot_Tub_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 86,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Far_Infrared_Sauna_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 60
		},
		"Plumbing_Sauna_Far_Infrared_Sauna_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Far_Infrared_Sauna_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 45
		},
		"Plumbing_Sauna_Far_Infrared_Sauna_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 114,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Far_Infrared_Sauna_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 72
		},
		"Plumbing_Sauna_Far_Infrared_Sauna_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 182,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Room_Sauna_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 60
		},
		"Plumbing_Sauna_Room_Sauna_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Room_Sauna_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 45
		},
		"Plumbing_Sauna_Room_Sauna_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 114,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Room_Sauna_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 72
		},
		"Plumbing_Sauna_Room_Sauna_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 182,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Room_Steam_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 60
		},
		"Plumbing_Sauna_Room_Steam_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Room_Steam_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 45
		},
		"Plumbing_Sauna_Room_Steam_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 114,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Room_Steam_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 72
		},
		"Plumbing_Sauna_Room_Steam_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 182,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Control_Sauna_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 4
		},
		"Plumbing_Sauna_Control_Sauna_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 7,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Control_Sauna_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 4
		},
		"Plumbing_Sauna_Control_Sauna_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 22,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Control_Sauna_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 60
		},
		"Plumbing_Sauna_Control_Sauna_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Control_Steam_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 4
		},
		"Plumbing_Sauna_Control_Steam_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 7,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Control_Steam_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 4
		},
		"Plumbing_Sauna_Control_Steam_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 22,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Control_Steam_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 60
		},
		"Plumbing_Sauna_Control_Steam_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Steam_Head_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 3
		},
		"Plumbing_Sauna_Steam_Head_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 7,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Steam_Head_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 3
		},
		"Plumbing_Sauna_Steam_Head_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 7,
			"groupLabel": "Metric"
		},
		"Plumbing_Sauna_Steam_Head_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 12
		},
		"Plumbing_Sauna_Steam_Head_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 30,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Base_Neo_Angle_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 36
		},
		"Plumbing_Shower_Base_Neo_Angle_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Base_Neo_Angle_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 36
		},
		"Plumbing_Shower_Base_Neo_Angle_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Base_Rectangular_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 60
		},
		"Plumbing_Shower_Base_Rectangular_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 152,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Base_Rectangular_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 36
		},
		"Plumbing_Shower_Base_Rectangular_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Base_Round_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 36
		},
		"Plumbing_Shower_Base_Round_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Base_Round_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 36
		},
		"Plumbing_Shower_Base_Round_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Base_Square_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 36
		},
		"Plumbing_Shower_Base_Square_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Base_Square_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 36
		},
		"Plumbing_Shower_Base_Square_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 91,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_One_Handled_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 6
		},
		"Plumbing_Shower_Control_One_Handled_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_One_Handled_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 6
		},
		"Plumbing_Shower_Control_One_Handled_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_One_Handled_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 40
		},
		"Plumbing_Shower_Control_One_Handled_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 101,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_Two_Handled_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 9
		},
		"Plumbing_Shower_Control_Two_Handled_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 22,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_Two_Handled_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 9
		},
		"Plumbing_Shower_Control_Two_Handled_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 22,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_Two_Handled_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 40
		},
		"Plumbing_Shower_Control_Two_Handled_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 101,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_Three_Handled_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 5
		},
		"Plumbing_Shower_Control_Three_Handled_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 12,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_Three_Handled_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 12
		},
		"Plumbing_Shower_Control_Three_Handled_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 30,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_Three_Handled_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 40
		},
		"Plumbing_Shower_Control_Three_Handled_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 101,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_Four_Handled_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 14
		},
		"Plumbing_Shower_Control_Four_Handled_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 35,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_Four_Handled_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 5
		},
		"Plumbing_Shower_Control_Four_Handled_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 12,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Control_Four_Handled_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 40
		},
		"Plumbing_Shower_Control_Four_Handled_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 101,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Drain_Linear_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 24
		},
		"Plumbing_Shower_Drain_Linear_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 60,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Drain_Linear_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 4
		},
		"Plumbing_Shower_Drain_Linear_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 10,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Drain_Square_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 6
		},
		"Plumbing_Shower_Drain_Square_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Drain_Square_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 6
		},
		"Plumbing_Shower_Drain_Square_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Drain_Round_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 6
		},
		"Plumbing_Shower_Drain_Round_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Drain_Round_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 6
		},
		"Plumbing_Shower_Drain_Round_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Head_Ceiling_Mounted_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 6
		},
		"Plumbing_Shower_Head_Ceiling_Mounted_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Head_Ceiling_Mounted_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 6
		},
		"Plumbing_Shower_Head_Ceiling_Mounted_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Head_Freestanding_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 88
		},
		"Plumbing_Shower_Head_Freestanding_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 223,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Head_Wall_Mounted_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 6
		},
		"Plumbing_Shower_Head_Wall_Mounted_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Head_Wall_Mounted_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 6
		},
		"Plumbing_Shower_Head_Wall_Mounted_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_Head_Wall_Mounted_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 84
		},
		"Plumbing_Shower_Head_Wall_Mounted_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 213,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower-Head_Wall_Mounted-Measure-Point": {
			"isRadio": true,
			"label": "Measure Point",
			"value": "Mount",
			"options": [
				{
					"value": "Mount",
					"label": "Mount"
				},
				{
					"value": "Head",
					"label": "Head"
				}
			]
		},
		"Plumbing_Shower_System_Built-In_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 6
		},
		"Plumbing_Shower_System_Built-In_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_System_Built-In_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 50
		},
		"Plumbing_Shower_System_Built-In_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 127,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_System_Built-In_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 34
		},
		"Plumbing_Shower_System_Built-In_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 86,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_System_Exposed_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 6
		},
		"Plumbing_Shower_System_Exposed_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 15,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_System_Exposed_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 50
		},
		"Plumbing_Shower_System_Exposed_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 127,
			"groupLabel": "Metric"
		},
		"Plumbing_Shower_System_Exposed_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 34
		},
		"Plumbing_Shower_System_Exposed_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 86,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Bar_Prep_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 14
		},
		"Plumbing_Sink_Bar_Prep_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 35,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Bar_Prep_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 14
		},
		"Plumbing_Sink_Bar_Prep_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 35,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Bar_Prep_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 8
		},
		"Plumbing_Sink_Bar_Prep_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 20,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Kitchen_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 30
		},
		"Plumbing_Sink_Kitchen_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 76,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Kitchen_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 22
		},
		"Plumbing_Sink_Kitchen_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 55,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Kitchen_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 12
		},
		"Plumbing_Sink_Kitchen_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 30,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Lavatory_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 16
		},
		"Plumbing_Sink_Lavatory_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 40,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Lavatory_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 16
		},
		"Plumbing_Sink_Lavatory_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 40,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Lavatory_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 8
		},
		"Plumbing_Sink_Lavatory_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 20,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Utility_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 24
		},
		"Plumbing_Sink_Utility_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 60,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Utility_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 18
		},
		"Plumbing_Sink_Utility_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 45,
			"groupLabel": "Metric"
		},
		"Plumbing_Sink_Utility_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 14
		},
		"Plumbing_Sink_Utility_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 35,
			"groupLabel": "Metric"
		},
		"Plumbing_Toilet_Floor_Mounted_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 20
		},
		"Plumbing_Toilet_Floor_Mounted_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 50,
			"groupLabel": "Metric"
		},
		"Plumbing_Toilet_Floor_Mounted_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 30
		},
		"Plumbing_Toilet_Floor_Mounted_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 76,
			"groupLabel": "Metric"
		},
		"Plumbing_Toilet_Floor_Mounted_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 30
		},
		"Plumbing_Toilet_Floor_Mounted_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 76,
			"groupLabel": "Metric"
		},
		"Plumbing_Toilet_Wall_Mounted_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 15
		},
		"Plumbing_Toilet_Wall_Mounted_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 38,
			"groupLabel": "Metric"
		},
		"Plumbing_Toilet_Wall_Mounted_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 22
		},
		"Plumbing_Toilet_Wall_Mounted_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 55,
			"groupLabel": "Metric"
		},
		"Plumbing_Toilet_Wall_Mounted_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 15
		},
		"Plumbing_Toilet_Wall_Mounted_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 38,
			"groupLabel": "Metric"
		},
		"Plumbing_Toilet_Wall_Mounted_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 5
		},
		"Plumbing_Toilet_Wall_Mounted_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 12,
			"groupLabel": "Metric"
		},
		"Plumbing_Urinal_Floor_Mounted_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 18
		},
		"Plumbing_Urinal_Floor_Mounted_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 45,
			"groupLabel": "Metric"
		},
		"Plumbing_Urinal_Floor_Mounted_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 15
		},
		"Plumbing_Urinal_Floor_Mounted_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 38,
			"groupLabel": "Metric"
		},
		"Plumbing_Urinal_Floor_Mounted_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 40
		},
		"Plumbing_Urinal_Floor_Mounted_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 101,
			"groupLabel": "Metric"
		},
		"Plumbing_Urinal_Wall_Mounted_Imperial-Width-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (in)",
			"value": 12
		},
		"Plumbing_Urinal_Wall_Mounted_Metric-Width-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Width (cm)",
			"value": 30,
			"groupLabel": "Metric"
		},
		"Plumbing_Urinal_Wall_Mounted_Imperial-Depth-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (in)",
			"value": 15
		},
		"Plumbing_Urinal_Wall_Mounted_Metric-Depth-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Depth (Cm)",
			"value": 38,
			"groupLabel": "Metric"
		},
		"Plumbing_Urinal_Wall_Mounted_Imperial-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (in)",
			"value": 24
		},
		"Plumbing_Urinal_Wall_Mounted_Metric-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Height (cm)",
			"value": 60,
			"groupLabel": "Metric"
		},
		"Plumbing_Urinal_Wall_Mounted_Imperial-Hanging-Height-In": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (in)",
			"value": 24
		},
		"Plumbing_Urinal_Wall_Mounted_Metric-Hanging-Height-Cm": {
			"isDouble": true,
			"isDoubleIn1Columns": true,
			"label": "Default Hanging Height (cm)",
			"value": 60,
			"groupLabel": "Metric"
		},
		"Project_Deadlines_Appliances": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Appliances"
		},
		"Project_Deadlines_Building-Materials": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Building Materials"
		},
		"Project_Deadlines_Doors-Windows": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Doors & Windows"
		},
		"Project_Deadlines_Electrical": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Electrical"
		},
		"Project_Deadlines_Equipment": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Equipment"
		},
		"Project_Deadlines_Carpet": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Carpet",
			"labelHeader": "Finishes",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Concrete": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Concrete"
		},
		"Project_Deadlines_Metal": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Metal",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Miscellaneous": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Miscellaneous",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Paint": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Paint",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Part": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Part",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Tile": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Tile",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Wall-Covering": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Wall Covering",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Wood-Stain": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Wood Stain",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Wood-Look-Flooring": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Wood-Look Flooring",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Wood-Timber": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Wood/Timber",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Slab": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Slab",
			"groupLabel": "Finishes"
		},
		"Project_Deadlines_Furnishings": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Furnishings"
		},
		"Project_Deadlines_Hardware": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Hardware"
		},
		"Project_Deadlines_HVAC": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "HVAC"
		},
		"Project_Deadlines_Landscaping": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Landscaping"
		},
		"Project_Deadlines_Lighting": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Lighting"
		},
		"Project_Deadlines_Millwork-Casework": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Millwork & Casework"
		},
		"Project_Deadlines_Mouldings": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Mouldings"
		},
		"Project_Deadlines_Plumbing": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Plumbing"
		},
		"General_Default-Supplier-Appliances": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Appliances",
			"connectedFieldKey": "General_Default-Supplier_Contact-Appliances"
		},
		"General_Default-Supplier_Contact-Appliances": {
			"isContactSetter": true,
			"value": null,
			"label": "Appliances"
		},
		"General_Default-Installer-Appliances": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Appliances",
			"connectedFieldKey": "General_Default-Installer_Contact-Appliances"
		},
		"General_Default-Installer_Contact-Appliances": {
			"isContactSetter": true,
			"value": null,
			"label": "Appliances"
		},
		"General_Default-Supplier-Building Materials": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Building Materials",
			"connectedFieldKey": "General_Default-Supplier_Contact-Building Materials"
		},
		"General_Default-Supplier_Contact-Building Materials": {
			"isContactSetter": true,
			"value": null,
			"label": "Building Materials"
		},
		"General_Default-Installer-Building Materials": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Building Materials",
			"connectedFieldKey": "General_Default-Installer_Contact-Building Materials"
		},
		"General_Default-Installer_Contact-Building Materials": {
			"isContactSetter": true,
			"value": null,
			"label": "Building Materials"
		},
		"General_Default-Supplier-Doors & Windows": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Doors & Windows",
			"connectedFieldKey": "General_Default-Supplier_Contact-Doors & Windows"
		},
		"General_Default-Supplier_Contact-Doors & Windows": {
			"isContactSetter": true,
			"value": null,
			"label": "Doors & Windows"
		},
		"General_Default-Installer-Doors & Windows": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Doors & Windows",
			"connectedFieldKey": "General_Default-Installer_Contact-Doors & Windows"
		},
		"General_Default-Installer_Contact-Doors & Windows": {
			"isContactSetter": true,
			"value": null,
			"label": "Doors & Windows"
		},
		"General_Default-Supplier-Electrical": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Electrical",
			"connectedFieldKey": "General_Default-Supplier_Contact-Electrical"
		},
		"General_Default-Supplier_Contact-Electrical": {
			"isContactSetter": true,
			"value": null,
			"label": "Electrical"
		},
		"General_Default-Installer-Electrical": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Electrical",
			"connectedFieldKey": "General_Default-Installer_Contact-Electrical"
		},
		"General_Default-Installer_Contact-Electrical": {
			"isContactSetter": true,
			"value": null,
			"label": "Electrical"
		},
		"General_Default-Supplier-Equipment": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Equipment",
			"connectedFieldKey": "General_Default-Supplier_Contact-Equipment"
		},
		"General_Default-Supplier_Contact-Equipment": {
			"isContactSetter": true,
			"value": null,
			"label": "Equipment"
		},
		"General_Default-Installer-Equipment": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Equipment",
			"connectedFieldKey": "General_Default-Installer_Contact-Equipment"
		},
		"General_Default-Installer_Contact-Equipment": {
			"isContactSetter": true,
			"value": null,
			"label": "Equipment"
		},
		"General_Default-Supplier-Finishes-Carpet": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Carpet",
			"labelHeader": "Finishes",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Carpet"
		},
		"General_Default-Supplier_Contact-Finishes-Carpet": {
			"isContactSetter": true,
			"value": null,
			"label": "Carpet"
		},
		"General_Default-Installer-Finishes-Carpet": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Carpet",
			"labelHeader": "Finishes",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Carpet"
		},
		"General_Default-Installer_Contact-Finishes-Carpet": {
			"isContactSetter": true,
			"value": null,
			"label": "Carpet"
		},
		"General_Default-Supplier-Finishes-Metal": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Metal",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Metal"
		},
		"General_Default-Supplier_Contact-Finishes-Metal": {
			"isContactSetter": true,
			"value": null,
			"label": "Metal"
		},
		"General_Default-Installer-Finishes-Metal": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Metal",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Metal"
		},
		"General_Default-Installer_Contact-Finishes-Metal": {
			"isContactSetter": true,
			"value": null,
			"label": "Metal"
		},
		"General_Default-Supplier-Finishes-Miscellaneous": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Miscellaneous",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Miscellaneous"
		},
		"General_Default-Supplier_Contact-Finishes-Miscellaneous": {
			"isContactSetter": true,
			"value": null,
			"label": "Miscellaneous"
		},
		"General_Default-Installer-Finishes-Miscellaneous": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Miscellaneous",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Miscellaneous"
		},
		"General_Default-Installer_Contact-Finishes-Miscellaneous": {
			"isContactSetter": true,
			"value": null,
			"label": "Miscellaneous"
		},
		"General_Default-Supplier-Finishes-Paint": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Paint",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Paint"
		},
		"General_Default-Supplier_Contact-Finishes-Paint": {
			"isContactSetter": true,
			"value": null,
			"label": "Paint"
		},
		"General_Default-Installer-Finishes-Paint": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Paint",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Paint"
		},
		"General_Default-Installer_Contact-Finishes-Paint": {
			"isContactSetter": true,
			"value": null,
			"label": "Paint"
		},
		"General_Default-Supplier-Finishes-Part": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Part",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Part"
		},
		"General_Default-Supplier_Contact-Finishes-Part": {
			"isContactSetter": true,
			"value": null,
			"label": "Part"
		},
		"General_Default-Installer-Finishes-Part": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Part",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Part"
		},
		"General_Default-Installer_Contact-Finishes-Part": {
			"isContactSetter": true,
			"value": null,
			"label": "Part"
		},
		"General_Default-Supplier-Finishes-Tile": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Tile",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Tile"
		},
		"General_Default-Supplier_Contact-Finishes-Tile": {
			"isContactSetter": true,
			"value": null,
			"label": "Tile"
		},
		"General_Default-Installer-Finishes-Tile": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Tile",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Tile"
		},
		"General_Default-Installer_Contact-Finishes-Tile": {
			"isContactSetter": true,
			"value": null,
			"label": "Tile"
		},
		"General_Default-Supplier-Finishes-Wall Covering": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Wall Covering",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Wall Covering"
		},
		"General_Default-Supplier_Contact-Finishes-Wall Covering": {
			"isContactSetter": true,
			"value": null,
			"label": "Wall Covering"
		},
		"General_Default-Installer-Finishes-Wall Covering": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Wall Covering",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Wall Covering"
		},
		"General_Default-Installer_Contact-Finishes-Wall Covering": {
			"isContactSetter": true,
			"value": null,
			"label": "Wall Covering"
		},
		"General_Default-Supplier-Finishes-Wood Stain": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Wood Stain",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Wood Stain"
		},
		"General_Default-Supplier_Contact-Finishes-Wood Stain": {
			"isContactSetter": true,
			"value": null,
			"label": "Wood Stain"
		},
		"General_Default-Installer-Finishes-Wood Stain": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Wood Stain",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Wood Stain"
		},
		"General_Default-Installer_Contact-Finishes-Wood Stain": {
			"isContactSetter": true,
			"value": null,
			"label": "Wood Stain"
		},
		"General_Default-Supplier-Finishes-Wood-Look Flooring": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Wood-Look Flooring",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Wood-Look Flooring"
		},
		"General_Default-Supplier_Contact-Finishes-Wood-Look Flooring": {
			"isContactSetter": true,
			"value": null,
			"label": "Wood-Look Flooring"
		},
		"General_Default-Installer-Finishes-Wood-Look Flooring": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Wood-Look Flooring",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Wood-Look Flooring"
		},
		"General_Default-Installer_Contact-Finishes-Wood-Look Flooring": {
			"isContactSetter": true,
			"value": null,
			"label": "Wood-Look Flooring"
		},
		"General_Default-Supplier-Finishes-Wood/Timber": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Wood/Timber",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Wood/Timber"
		},
		"General_Default-Supplier_Contact-Finishes-Wood/Timber": {
			"isContactSetter": true,
			"value": null,
			"label": "Wood/Timber"
		},
		"General_Default-Installer-Finishes-Wood/Timber": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Wood/Timber",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Wood/Timber"
		},
		"General_Default-Installer_Contact-Finishes-Wood/Timber": {
			"isContactSetter": true,
			"value": null,
			"label": "Wood/Timber"
		},
		"General_Default-Supplier-Finishes-Slab": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Slab",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Supplier_Contact-Finishes-Slab"
		},
		"General_Default-Supplier_Contact-Finishes-Slab": {
			"isContactSetter": true,
			"value": null,
			"label": "Slab"
		},
		"General_Default-Installer-Finishes-Slab": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Slab",
			"groupLabel": "Finishes",
			"connectedFieldKey": "General_Default-Installer_Contact-Finishes-Slab"
		},
		"General_Default-Installer_Contact-Finishes-Slab": {
			"isContactSetter": true,
			"value": null,
			"label": "Slab"
		},
		"General_Default-Supplier-Furnishings": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Furnishings",
			"connectedFieldKey": "General_Default-Supplier_Contact-Furnishings"
		},
		"General_Default-Supplier_Contact-Furnishings": {
			"isContactSetter": true,
			"value": null,
			"label": "Furnishings"
		},
		"General_Default-Installer-Furnishings": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Furnishings",
			"connectedFieldKey": "General_Default-Installer_Contact-Furnishings"
		},
		"General_Default-Installer_Contact-Furnishings": {
			"isContactSetter": true,
			"value": null,
			"label": "Furnishings"
		},
		"General_Default-Supplier-Hardware": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Hardware",
			"connectedFieldKey": "General_Default-Supplier_Contact-Hardware"
		},
		"General_Default-Supplier_Contact-Hardware": {
			"isContactSetter": true,
			"value": null,
			"label": "Hardware"
		},
		"General_Default-Installer-Hardware": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Hardware",
			"connectedFieldKey": "General_Default-Installer_Contact-Hardware"
		},
		"General_Default-Installer_Contact-Hardware": {
			"isContactSetter": true,
			"value": null,
			"label": "Hardware"
		},
		"General_Default-Supplier-HVAC": {
			"isSupplierSetter": true,
			"value": null,
			"label": "HVAC",
			"connectedFieldKey": "General_Default-Supplier_Contact-HVAC"
		},
		"General_Default-Supplier_Contact-HVAC": {
			"isContactSetter": true,
			"value": null,
			"label": "HVAC"
		},
		"General_Default-Installer-HVAC": {
			"isInstallerSetter": true,
			"value": null,
			"label": "HVAC",
			"connectedFieldKey": "General_Default-Installer_Contact-HVAC"
		},
		"General_Default-Installer_Contact-HVAC": {
			"isContactSetter": true,
			"value": null,
			"label": "HVAC"
		},
		"General_Default-Supplier-Landscaping": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Landscaping",
			"connectedFieldKey": "General_Default-Supplier_Contact-Landscaping"
		},
		"General_Default-Supplier_Contact-Landscaping": {
			"isContactSetter": true,
			"value": null,
			"label": "Landscaping"
		},
		"General_Default-Installer-Landscaping": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Landscaping",
			"connectedFieldKey": "General_Default-Installer_Contact-Landscaping"
		},
		"General_Default-Installer_Contact-Landscaping": {
			"isContactSetter": true,
			"value": null,
			"label": "Landscaping"
		},
		"General_Default-Supplier-Lighting": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Lighting",
			"connectedFieldKey": "General_Default-Supplier_Contact-Lighting"
		},
		"General_Default-Supplier_Contact-Lighting": {
			"isContactSetter": true,
			"value": null,
			"label": "Lighting"
		},
		"General_Default-Installer-Lighting": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Lighting",
			"connectedFieldKey": "General_Default-Installer_Contact-Lighting"
		},
		"General_Default-Installer_Contact-Lighting": {
			"isContactSetter": true,
			"value": null,
			"label": "Lighting"
		},
		"General_Default-Supplier-Millwork & Casework": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Millwork & Casework",
			"connectedFieldKey": "General_Default-Supplier_Contact-Millwork & Casework"
		},
		"General_Default-Supplier_Contact-Millwork & Casework": {
			"isContactSetter": true,
			"value": null,
			"label": "Millwork & Casework"
		},
		"General_Default-Installer-Millwork & Casework": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Millwork & Casework",
			"connectedFieldKey": "General_Default-Installer_Contact-Millwork & Casework"
		},
		"General_Default-Installer_Contact-Millwork & Casework": {
			"isContactSetter": true,
			"value": null,
			"label": "Millwork & Casework"
		},
		"General_Default-Supplier-Mouldings": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Mouldings",
			"connectedFieldKey": "General_Default-Supplier_Contact-Mouldings"
		},
		"General_Default-Supplier_Contact-Mouldings": {
			"isContactSetter": true,
			"value": null,
			"label": "Mouldings"
		},
		"General_Default-Installer-Mouldings": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Mouldings",
			"connectedFieldKey": "General_Default-Installer_Contact-Mouldings"
		},
		"General_Default-Installer_Contact-Mouldings": {
			"isContactSetter": true,
			"value": null,
			"label": "Mouldings"
		},
		"General_Default-Supplier-Plumbing": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Plumbing",
			"connectedFieldKey": "General_Default-Supplier_Contact-Plumbing"
		},
		"General_Default-Supplier_Contact-Plumbing": {
			"isContactSetter": true,
			"value": null,
			"label": "Plumbing"
		},
		"General_Default-Installer-Plumbing": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Plumbing",
			"connectedFieldKey": "General_Default-Installer_Contact-Plumbing"
		},
		"General_Default-Installer_Contact-Plumbing": {
			"isContactSetter": true,
			"value": null,
			"label": "Plumbing"
		},
		"General_Default-Procurement-Appliances": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Appliances"
		},
		"General_Default-Procurement-Building Materials": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Building Materials"
		},
		"General_Default-Procurement-Doors & Windows": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Doors & Windows"
		},
		"General_Default-Procurement-Electrical": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Electrical"
		},
		"General_Default-Procurement-Equipment": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Equipment"
		},
		"General_Default-Procurement-Finishes-Carpet": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Carpet",
			"labelHeader": "Finishes",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Finishes-Metal": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Metal",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Finishes-Miscellaneous": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Miscellaneous",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Finishes-Paint": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Paint",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Finishes-Part": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Part",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Finishes-Tile": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Tile",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Finishes-Wall Covering": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Wall Covering",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Finishes-Wood Stain": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Wood Stain",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Finishes-Wood-Look Flooring": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Wood-Look Flooring",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Finishes-Wood/Timber": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Wood/Timber",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Finishes-Slab": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Slab",
			"groupLabel": "Finishes"
		},
		"General_Default-Procurement-Furnishings": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Furnishings"
		},
		"General_Default-Procurement-Hardware": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Hardware"
		},
		"General_Default-Procurement-HVAC": {
			"isProcurementSetter": true,
			"value": null,
			"label": "HVAC"
		},
		"General_Default-Procurement-Landscaping": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Landscaping"
		},
		"General_Default-Procurement-Lighting": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Lighting"
		},
		"General_Default-Procurement-Millwork & Casework": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Millwork & Casework"
		},
		"General_Default-Procurement-Mouldings": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Mouldings"
		},
		"General_Default-Procurement-Plumbing": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Plumbing"
		},
		"Estimates_Area-Measuring-Ft": {
			"isRadio": true,
			"label": "Imperial",
			"value": "1",
			"options": [
				{
					"value": "1",
					"label": "1 (sq. ft)"
				},
				{
					"value": "0.5",
					"label": "0.5 (sq. ft)"
				},
				{
					"value": "0.25",
					"label": "0.25 (sq. ft)"
				},
				{
					"value": "0.125",
					"label": "0.125 (sq. ft)"
				}
			]
		},
		"Estimates_Area-Measuring-M": {
			"isRadio": true,
			"label": "Metric",
			"value": "0.30",
			"options": [
				{
					"value": "0.30",
					"label": "0.30 (sq. m)"
				},
				{
					"value": "0.15",
					"label": "0.15 (sq. m)"
				},
				{
					"value": "0.08",
					"label": "0.08 (sq. m)"
				},
				{
					"value": "0.04",
					"label": "0.04 (sq. m)"
				}
			]
		},
		"Estimates_Linear-Measuring-Ft": {
			"isRadio": true,
			"label": "Imperial",
			"value": "1/4",
			"options": [
				{
					"value": "1/4",
					"label": "1/4 (in)"
				},
				{
					"value": "1/8",
					"label": "1/8 (in)"
				},
				{
					"value": "1/16",
					"label": "1/16 (in)"
				},
				{
					"value": "1/32",
					"label": "1/32 (in)"
				}
			]
		},
		"Estimates_Linear-Measuring-M": {
			"isRadio": true,
			"label": "Metric",
			"value": "0.5",
			"options": [
				{
					"value": "0.5",
					"label": "0.5 (cm)"
				},
				{
					"value": "0.3",
					"label": "0.3 (cm)"
				},
				{
					"value": "0.15",
					"label": "0.15 (cm)"
				},
				{
					"value": "0.1",
					"label": "0.1 (cm)"
				}
			]
		},
		"Estimates_Area-Measuring-Accuracy-Ft": {
			"isRadio": true,
			"label": "Imperial",
			"value": "1",
			"options": [
				{
					"value": "1",
					"label": "1 sqft"
				},
				{
					"value": "0.5",
					"label": "0.5 sqft"
				},
				{
					"value": "0.25",
					"label": "0.25 sqft"
				},
				{
					"value": "0.125",
					"label": "0.125 sqft"
				}
			]
		},
		"Estimates_Area-Measuring-Accuracy-M": {
			"isRadio": true,
			"label": "Metric",
			"value": "0.30",
			"options": [
				{
					"value": "0.30",
					"label": "0.30 sqm"
				},
				{
					"value": "0.15",
					"label": "0.15 sqm"
				},
				{
					"value": "0.08",
					"label": "0.08 sqm"
				},
				{
					"value": "0.04",
					"label": "0.04 sqm"
				}
			]
		},
		"Estimates_Linear-Measuring-Accuracy-Ft": {
			"isRadio": true,
			"label": "Imperial",
			"value": "1/4",
			"options": [
				{
					"value": "1/4",
					"label": "1/4 in"
				},
				{
					"value": "1/8",
					"label": "1/8 in"
				},
				{
					"value": "1/16",
					"label": "1/16 in"
				},
				{
					"value": "1/32",
					"label": "1/32 in"
				}
			]
		},
		"Estimates_Linear-Measuring-Accuracy-M": {
			"isRadio": true,
			"label": "Metric",
			"value": "0.5",
			"options": [
				{
					"value": "0.5",
					"label": "0.5 cm"
				},
				{
					"value": "0.3",
					"label": "0.3 cm"
				},
				{
					"value": "0.15",
					"label": "0.15 cm)"
				},
				{
					"value": "0.1",
					"label": "0.1 cm"
				}
			]
		},
		"Measurements_Ceiling-Height-In": {
			"isDouble": true,
			"label": "Default Ceiling Height (in)",
			"value": 96
		},
		"Measurements_Ceiling-Height-Cm": {
			"isDouble": true,
			"label": "Default Ceiling Height (cm)",
			"value": 240,
			"groupLabel": "Metric"
		},
		"Measurements_Wall-Thickness-In": {
			"isDouble": true,
			"label": "Depth (in)",
			"value": 4.5
		},
		"Measurements_Default-Height-Base-Category": {
			"isDouble": true,
			"label": "Default Height for Base Category",
			"value": 6
		},
		"Measurements_Wall-Thickness-Cm": {
			"isDouble": true,
			"label": "Depth (cm)",
			"value": 100,
			"groupLabel": "Metric"
		},
		"Units": {
			"isRadio": true,
			"value": "Imperial (in)",
			"options": [
				{
					"value": "Imperial (in)",
					"label": "Imperial (in)"
				},
				{
					"value": "Metric (cm)",
					"label": "Metric (cm)"
				}
			]
		},
		"Nudge-Increments_Book_Small_Nudge-Px": {
			"isDouble": true,
			"isDoubleIn1Columns": false,
			"label": "Small Nudge (px)",
			"value": 1
		},
		"Nudge-Increments_Book_Big_Nudge-Px": {
			"isDouble": true,
			"isDoubleIn1Columns": false,
			"label": "Big Nudge (px)",
			"value": 10
		},
		"Nudge-Increments_Book_Nudge-Cm": {
			"isDouble": true,
			"label": "Default Nudge (cm)",
			"value": 0.15,
			"groupLabel": "Metric"
		},
		"Nudge-Increments_Design-Set_Nudge-In": {
			"isDouble": true,
			"label": "Default Nudge (in)",
			"value": 1
		},
		"Nudge-Increments_Design-Set_Nudge-Cm": {
			"isDouble": true,
			"label": "Default Nudge (cm)",
			"value": 2,
			"groupLabel": "Metric"
		},
		"Wastage_Carpet-Percent": {
			"isDouble": true,
			"label": "Default Carpet (%)",
			"value": 20
		},
		"Wastage_Concrete-Percent": {
			"isDouble": true,
			"label": "Default Concrete (%)",
			"value": 10
		},
		"Wastage_Masonry-Percent": {
			"isDouble": true,
			"label": "Default Masonry (%)",
			"value": 10
		},
		"Wastage_Metal-Percent": {
			"isDouble": true,
			"label": "Default Metal (%)",
			"value": 10
		},
		"Wastage_Miscellaneous-Percent": {
			"isDouble": true,
			"label": "Default Miscellaneous (%)",
			"value": 10
		},
		"Wastage_Moulding-Percent": {
			"isDouble": true,
			"label": "Default Moulding (%)",
			"value": 10
		},
		"Wastage_Paint-Percent": {
			"isDouble": true,
			"label": "Default Paint (%)",
			"value": 30
		},
		"Wastage_Part-Percent": {
			"isDouble": true,
			"label": "Default Part (%)",
			"value": 10
		},
		"Wastage_Roofing-Percent": {
			"isDouble": true,
			"label": "Default Roofing (%)",
			"value": 10
		},
		"Wastage_Siding-Percent": {
			"isDouble": true,
			"label": "Default Siding (%)",
			"value": 10
		},
		"Wastage_Slab-Percent": {
			"isDouble": true,
			"label": "Default Slab (%)",
			"value": 10
		},
		"Wastage_Tile-Percent": {
			"isDouble": true,
			"label": "Default Tile (%)",
			"value": 15
		},
		"Wastage_Wall_Covering-Percent": {
			"isDouble": true,
			"label": "Default Wall Covering (%)",
			"value": 10
		},
		"Wastage_Wall_Ceiling_Panel-Percent": {
			"isDouble": true,
			"label": "Default Wall Ceiling Panel (%)",
			"value": 10
		},
		"Wastage_Wood_Stain-Percent": {
			"isDouble": true,
			"label": "Default Wood Stain (%)",
			"value": 30
		},
		"Wastage_Wood_Look_Flooring-Percent": {
			"isDouble": true,
			"label": "Default Wood Look Flooring (%)",
			"value": 10
		},
		"Plan-Scale_Architectural_Imperial": {
			"isRadio": true,
			"value": "1/4 (in) = 1 (ft)",
			"options": [
				{
					"value": "1 1/2 (in) = 1 (ft)",
					"label": "1 1/2 (in) = 1 (ft)"
				},
				{
					"value": "1 (in) = 1 (ft)",
					"label": "1 (in) = 1 (ft)"
				},
				{
					"value": "3/4 (in) = 1 (ft)",
					"label": "3/4 (in) = 1 (ft)"
				},
				{
					"value": "1/2 (in) = 1 (ft)",
					"label": "1/2 (in) = 1 (ft)"
				},
				{
					"value": "3/8 (in) = 1 (ft)",
					"label": "3/8 (in) = 1 (ft)"
				},
				{
					"value": "1/4 (in) = 1 (ft)",
					"label": "1/4 (in) = 1 (ft)"
				},
				{
					"value": "3/16 (in) = 1 (ft)",
					"label": "3/16 (in) = 1 (ft)"
				},
				{
					"value": "1/8 (in) = 1 (ft)",
					"label": "1/8 (in) = 1 (ft)"
				},
				{
					"value": "3/32 (in) = 1 (ft)",
					"label": "3/32 (in) = 1 (ft)"
				},
				{
					"value": "1/16 (in) = 1 (ft)",
					"label": "1/16 (in) = 1 (ft)"
				}
			]
		},
		"Item-Tags_Appliances_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Appliances",
			"isReadOnlyString": true
		},
		"Item-Tags_Appliances_Abbreviation": {
			"isString": true,
			"value": "AP",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Appliances_Tag-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Appliances_Text-Color": {
			"isColorPicker": true,
			"value": "#292D32",
			"isColorPickerGroup": true
		},
		"Item-Tags_Building-Materials_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Building Materials",
			"isReadOnlyString": true
		},
		"Item-Tags_Building-Materials_Abbreviation": {
			"isString": true,
			"value": "BM",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Building-Materials_Tag-Color": {
			"isColorPicker": true,
			"value": "#6B767A",
			"isColorPickerGroup": true
		},
		"Item-Tags_Building-Materials_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Appliances": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "AP-01"
		},
		"Item-Tags_Building-Materials": {
			"isString": true,
			"isColorPickerGroup": true,
			"labelValue": "BM-01",
			"isReadOnlyString": true
		},
		"Item-Tags_Header-Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"labelHeader": "Division",
			"isReadOnlyString": true
		},
		"Item-Tags_Header-Abbreviation": {
			"isString": true,
			"isColorPickerGroup": true,
			"labelHeader": "Abbreviation",
			"isReadOnlyString": true
		},
		"Item-Tags_Header-Tag-Color": {
			"isString": true,
			"isColorPickerGroup": true,
			"labelHeader": "Tag Color",
			"isReadOnlyString": true
		},
		"Item-Tags_Header-Text-Color": {
			"isString": true,
			"isColorPickerGroup": true,
			"labelHeader": "Text Color",
			"isReadOnlyString": true
		},
		"Item-Tags_Header-Tag-Preview": {
			"isString": true,
			"isColorPickerGroup": true,
			"labelHeader": "Tag Preview",
			"isReadOnlyString": true
		},
		"Item-Tags_Doors-&-Windows_Abbreviation": {
			"isString": true,
			"value": "DW",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Doors-&-Windows_Tag-Color": {
			"isColorPicker": true,
			"value": "#70410B",
			"isColorPickerGroup": true
		},
		"Item-Tags_Doors-&-Windows_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Doors-&-Windows": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "DW-01"
		},
		"Item-Tags_Doors-&-Windows_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Doors & Windows",
			"isReadOnlyString": true
		},
		"Item-Tags_Electrical_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Electrical",
			"isReadOnlyString": true
		},
		"Item-Tags_Electrical_Abbreviation": {
			"isString": true,
			"value": "EL",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Electrical_Tag-Color": {
			"isColorPicker": true,
			"value": "#A5654F",
			"isColorPickerGroup": true
		},
		"Item-Tags_Electrical_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Electrical": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "EL-01"
		},
		"Item-Tags_Equipment_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Equipment",
			"isReadOnlyString": true
		},
		"Item-Tags_Equipment_Abbreviation": {
			"isString": true,
			"value": "EQ",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Equipment_Tag-Color": {
			"isColorPicker": true,
			"value": "#8349A6",
			"isColorPickerGroup": true
		},
		"Item-Tags_Equipment_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Equipment": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "EQ-01"
		},
		"Item-Tags_Finishes_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Finishes",
			"isReadOnlyString": true
		},
		"Item-Tags_Finishes_Abbreviation": {
			"isString": true,
			"value": "FN",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Finishes_Tag-Color": {
			"isColorPicker": true,
			"value": "#67948B",
			"isColorPickerGroup": true
		},
		"Item-Tags_Finishes_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Finishes": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "FN-01"
		},
		"Item-Tags_Furnishings_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Furnishings",
			"isReadOnlyString": true
		},
		"Item-Tags_Furnishings_Abbreviation": {
			"isString": true,
			"value": "FR",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Furnishings_Tag-Color": {
			"isColorPicker": true,
			"value": "#8684B1",
			"isColorPickerGroup": true
		},
		"Item-Tags_Furnishings_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Furnishings": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "FR-01"
		},
		"Item-Tags_Hardware_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Hardware",
			"isReadOnlyString": true
		},
		"Item-Tags_Hardware_Abbreviation": {
			"isString": true,
			"value": "HW",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Hardware_Tag-Color": {
			"isColorPicker": true,
			"value": "#3B7C8A",
			"isColorPickerGroup": true
		},
		"Item-Tags_Hardware_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Hardware": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "HW-01"
		},
		"Item-Tags_HVAC_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "HVAC",
			"isReadOnlyString": true
		},
		"Item-Tags_HVAC_Abbreviation": {
			"isString": true,
			"value": "HV",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_HVAC_Tag-Color": {
			"isColorPicker": true,
			"value": "#396AA7",
			"isColorPickerGroup": true
		},
		"Item-Tags_HVAC_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_HVAC": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "HV-01"
		},
		"Item-Tags_Lighting_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Lighting",
			"isReadOnlyString": true
		},
		"Item-Tags_Lighting_Abbreviation": {
			"isString": true,
			"value": "LG",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Lighting_Tag-Color": {
			"isColorPicker": true,
			"value": "#E7C85A",
			"isColorPickerGroup": true
		},
		"Item-Tags_Lighting_Text-Color": {
			"isColorPicker": true,
			"value": "#292D32",
			"isColorPickerGroup": true
		},
		"Item-Tags_Lighting": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "LG-01"
		},
		"Item-Tags_Landscaping_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Landscaping",
			"isReadOnlyString": true
		},
		"Item-Tags_Landscaping_Abbreviation": {
			"isString": true,
			"value": "LS",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Landscaping_Tag-Color": {
			"isColorPicker": true,
			"value": "#348246",
			"isColorPickerGroup": true
		},
		"Item-Tags_Landscaping_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Landscaping": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "LS-01"
		},
		"Item-Tags_Millwork-&-Casework_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Millwork & Casework",
			"isReadOnlyString": true
		},
		"Item-Tags_Millwork-&-Casework_Abbreviation": {
			"isString": true,
			"value": "MW",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Millwork-&-Casework_Tag-Color": {
			"isColorPicker": true,
			"value": "#946B3B",
			"isColorPickerGroup": true
		},
		"Item-Tags_Millwork-&-Casework_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Millwork-&-Casework": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "MW-01"
		},
		"Item-Tags_Mouldings_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Mouldings",
			"isReadOnlyString": true
		},
		"Item-Tags_Mouldings_Abbreviation": {
			"isString": true,
			"value": "ML",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Mouldings_Tag-Color": {
			"isColorPicker": true,
			"value": "#7C7269",
			"isColorPickerGroup": true
		},
		"Item-Tags_Mouldings_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Mouldings": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "ML-01"
		},
		"Item-Tags_Plumbing_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Plumbing",
			"isReadOnlyString": true
		},
		"Item-Tags_Plumbing_Abbreviation": {
			"isString": true,
			"value": "PL",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Plumbing_Tag-Color": {
			"isColorPicker": true,
			"value": "#5573AC",
			"isColorPickerGroup": true
		},
		"Item-Tags_Plumbing_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Plumbing": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "PL-01"
		},
		"Item-Tags_Masonry_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Masonry",
			"isReadOnlyString": true
		},
		"Item-Tags_Masonry_Abbreviation": {
			"isString": true,
			"value": "MN",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Masonry_Tag-Color": {
			"isColorPicker": true,
			"value": "#6B767A",
			"isColorPickerGroup": true
		},
		"Item-Tags_Masonry_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Masonry": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "MN-01"
		},
		"Item-Tags_Conveying-Equipment_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Conveying Equipment",
			"isReadOnlyString": true
		},
		"Item-Tags_Conveying-Equipment_Abbreviation": {
			"isString": true,
			"value": "CV",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Conveying-Equipment_Tag-Color": {
			"isColorPicker": true,
			"value": "#8349A6",
			"isColorPickerGroup": true
		},
		"Item-Tags_Conveying-Equipment_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Conveying-Equipment": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "CV-01"
		},
		"Item-Tags_Concrete_Division": {
			"isString": true,
			"isColorPickerGroup": true,
			"label": "Concrete",
			"isReadOnlyString": true
		},
		"Item-Tags_Concrete_Abbreviation": {
			"isString": true,
			"value": "CC",
			"isColorPickerGroup": true,
			"disabled": true
		},
		"Item-Tags_Concrete_Tag-Color": {
			"isColorPicker": true,
			"value": "#527F71",
			"isColorPickerGroup": true
		},
		"Item-Tags_Concrete_Text-Color": {
			"isColorPicker": true,
			"value": "#FFFFFF",
			"isColorPickerGroup": true
		},
		"Item-Tags_Concrete": {
			"isString": true,
			"isColorPickerGroup": true,
			"isReadOnlyString": true,
			"labelValue": "CC-01"
		},
		"General_Default-Supplier-Concrete": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Concrete",
			"connectedFieldKey": "General_Default-Supplier_Contact-Concrete"
		},
		"General_Default-Supplier_Contact-Concrete": {
			"isContactSetter": true,
			"value": null,
			"label": "Concrete"
		},
		"General_Default-Installer-Concrete": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Concrete",
			"connectedFieldKey": "General_Default-Installer_Contact-Concrete"
		},
		"General_Default-Installer_Contact-Concrete": {
			"isContactSetter": true,
			"value": null,
			"label": "Concrete"
		},
		"General_Default-Procurement-Concrete": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Concrete"
		},
		"General_Default-Supplier-Conveying Equipment": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Conveying Equipment",
			"connectedFieldKey": "General_Default-Supplier_Contact-Conveying Equipment"
		},
		"General_Default-Supplier_Contact-Conveying Equipment": {
			"isContactSetter": true,
			"value": null,
			"label": "Conveying Equipment"
		},
		"General_Default-Installer-Conveying Equipment": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Conveying Equipment",
			"connectedFieldKey": "General_Default-Installer_Contact-Conveying Equipment"
		},
		"General_Default-Installer_Contact-Conveying Equipment": {
			"isContactSetter": true,
			"value": null,
			"label": "Conveying Equipment"
		},
		"General_Default-Procurement-Conveying Equipment": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Conveying Equipment"
		},
		"General_Default-Supplier-Masonry": {
			"isSupplierSetter": true,
			"value": null,
			"label": "Masonry",
			"connectedFieldKey": "General_Default-Supplier_Contact-Masonry"
		},
		"General_Default-Supplier_Contact-Masonry": {
			"isContactSetter": true,
			"value": null,
			"label": "Masonry"
		},
		"General_Default-Installer-Masonry": {
			"isInstallerSetter": true,
			"value": null,
			"label": "Masonry",
			"connectedFieldKey": "General_Default-Installer_Contact-Masonry"
		},
		"General_Default-Installer_Contact-Masonry": {
			"isContactSetter": true,
			"value": null,
			"label": "Masonry"
		},
		"General_Default-Procurement-Masonry": {
			"isProcurementSetter": true,
			"value": null,
			"label": "Masonry"
		},
		"Project_Deadlines_Conveying-Equipment": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Conveying Equipment"
		},
		"Project_Deadlines_Masonry": {
			"isDeadlineSetter": true,
			"value": null,
			"label": "Masonry"
		},
		"General_Default-Division_Default-view": {
			"isRadio": true,
			"value": "All",
			"options": [
				{
					"value": "All",
					"label": "All"
				},
				{
					"value": "Appliances",
					"label": "Appliances"
				},
				{
					"value": "Building Materials",
					"label": "Building Materials"
				},
				{
					"value": "Concrete",
					"label": "Concrete"
				},
				{
					"value": "Conveying Equipment",
					"label": "Conveying Equipment"
				},
				{
					"value": "Doors & Windows",
					"label": "Doors & Windows"
				},
				{
					"value": "Electrical",
					"label": "Electrical"
				},
				{
					"value": "Equipment",
					"label": "Equipment"
				},
				{
					"value": "Finishes",
					"label": "Finishes"
				},
				{
					"value": "Furnishings",
					"label": "Furnishings"
				},
				{
					"value": "Hardware",
					"label": "Hardware"
				},
				{
					"value": "HVAC",
					"label": "HVAC"
				},
				{
					"value": "Lighting",
					"label": "Lighting"
				},
				{
					"value": "Landscaping",
					"label": "Landscaping"
				},
				{
					"value": "Masonry",
					"label": "Masonry"
				},
				{
					"value": "Millwork & Casework",
					"label": "Millwork & Casework"
				},
				{
					"value": "Mouldings",
					"label": "Mouldings"
				},
				{
					"value": "Plumbing",
					"label": "Plumbing"
				}
			]
		},
		"General_Project-Edit-Access_Access-Type": {
			"isRadio": true,
			"groupLabel": "Project Edit Access",
			"infoIcon": "Controls who within the organization can see and edit project data.",
			"value": "all",
			"options": [
				{
					"value": "all",
					"label": "All Org Members"
				},
				{
					"value": "stakeholders",
					"label": "Project Stakeholders Only"
				},
				{
					"value": "stakeholdersOnly",
					"label": "Project Stakeholders Only — hide other projects"
				}
			]
		},
		"General_Special-Attributes_View-Price": {
			"isToggle": true,
			"value": "true",
			"labelValue": "View Price"
		},
		"General_Special-Attributes_View-SKU-2": {
			"isToggle": true,
			"value": "true",
			"labelValue": "View SKU 2"
		},
		"General_Special-Attributes_View-Manufacturer": {
			"isToggle": true,
			"value": "true",
			"labelValue": "View Manufacturer"
		},
		"General_Special-Attributes_View-Manufacturer-SKU": {
			"isToggle": true,
			"value": "true",
			"labelValue": "View Manufacturer SKU"
		},
		"General_Special-Attributes_View-Supplier": {
			"isToggle": true,
			"value": "true",
			"labelValue": "View Supplier"
		}
	},
	"orgSetting": {
		"Books": {
			"Attributes": {
				"Default Attribute Visibility": {
					"values": [
						"Books_Page-settings_Hide-sku",
						"Books_Page-settings_Hide-item-code",
						"Books_Page-settings_Hide-manufacturer"
					]
				}
			},
			"Page Settings": {
				"values": [
					"Books_Page-settings_Ruler-label",
					"Books_Page-settings_Show-ruler",
					"Books_Page-settings_Grids-label",
					"Books_Page-settings_Show-grid",
					"Books_Page-settings_View-grid",
					"Books_Page-settings_Snap-elements",
					"Books_Page-settings_Grid-size",
					"Books_Page-settings_Grid-color-label",
					"Books_Page-settings_Grid-color-label",
					"Books_Page-settings_Grid-color",
					"Books_Page-settings_Show-guide-label",
					"Books_Page-settings_Show-guide",
					"Books_Page-settings_Guide-color-label",
					"Books_Page-settings_Guide-color"
				]
			},
			"Size": {
				"values": ["Books_Size_Orientation-Label", "Books_Size_Orientation", "Books_Size_Default-size"]
			}
		},
		"Default Installers": {
			"values": [
				"General_Default-Installer-Appliances",
				"General_Default-Installer_Contact-Appliances",
				"General_Default-Installer-Building Materials",
				"General_Default-Installer_Contact-Building Materials",
				"General_Default-Installer-Concrete",
				"General_Default-Installer_Contact-Concrete",
				"General_Default-Installer-Conveying Equipment",
				"General_Default-Installer_Contact-Conveying Equipment",
				"General_Default-Installer-Doors & Windows",
				"General_Default-Installer_Contact-Doors & Windows",
				"General_Default-Installer-Electrical",
				"General_Default-Installer_Contact-Electrical",
				"General_Default-Installer-Equipment",
				"General_Default-Installer_Contact-Equipment",
				"General_Default-Installer-Finishes-Carpet",
				"General_Default-Installer_Contact-Finishes-Carpet",
				"General_Default-Installer-Finishes-Metal",
				"General_Default-Installer_Contact-Finishes-Metal",
				"General_Default-Installer-Finishes-Miscellaneous",
				"General_Default-Installer_Contact-Finishes-Miscellaneous",
				"General_Default-Installer-Finishes-Paint",
				"General_Default-Installer_Contact-Finishes-Paint",
				"General_Default-Installer-Finishes-Part",
				"General_Default-Installer_Contact-Finishes-Part",
				"General_Default-Installer-Finishes-Slab",
				"General_Default-Installer_Contact-Finishes-Slab",
				"General_Default-Installer-Finishes-Tile",
				"General_Default-Installer_Contact-Finishes-Tile",
				"General_Default-Installer-Finishes-Wall Covering",
				"General_Default-Installer_Contact-Finishes-Wall Covering",
				"General_Default-Installer-Finishes-Wood Stain",
				"General_Default-Installer_Contact-Finishes-Wood Stain",
				"General_Default-Installer-Finishes-Wood-Look Flooring",
				"General_Default-Installer_Contact-Finishes-Wood-Look Flooring",
				"General_Default-Installer-Finishes-Wood/Timber",
				"General_Default-Installer_Contact-Finishes-Wood/Timber",
				"General_Default-Installer-Furnishings",
				"General_Default-Installer_Contact-Furnishings",
				"General_Default-Installer-Hardware",
				"General_Default-Installer_Contact-Hardware",
				"General_Default-Installer-HVAC",
				"General_Default-Installer_Contact-HVAC",
				"General_Default-Installer-Landscaping",
				"General_Default-Installer_Contact-Landscaping",
				"General_Default-Installer-Lighting",
				"General_Default-Installer_Contact-Lighting",
				"General_Default-Installer-Masonry",
				"General_Default-Installer_Contact-Masonry",
				"General_Default-Installer-Millwork & Casework",
				"General_Default-Installer_Contact-Millwork & Casework",
				"General_Default-Installer-Mouldings",
				"General_Default-Installer_Contact-Mouldings",
				"General_Default-Installer-Plumbing",
				"General_Default-Installer_Contact-Plumbing"
			],
			"__permissions": ["SettingsInstallerSupplierProcurement"]
		},
		"Default Procurement": {
			"values": [
				"General_Default-Procurement-Appliances",
				"General_Default-Procurement-Building Materials",
				"General_Default-Procurement-Concrete",
				"General_Default-Procurement-Conveying Equipment",
				"General_Default-Procurement-Doors & Windows",
				"General_Default-Procurement-Electrical",
				"General_Default-Procurement-Equipment",
				"General_Default-Procurement-Finishes-Carpet",
				"General_Default-Procurement-Finishes-Metal",
				"General_Default-Procurement-Finishes-Miscellaneous",
				"General_Default-Procurement-Finishes-Paint",
				"General_Default-Procurement-Finishes-Part",
				"General_Default-Procurement-Finishes-Slab",
				"General_Default-Procurement-Finishes-Tile",
				"General_Default-Procurement-Finishes-Wall Covering",
				"General_Default-Procurement-Finishes-Wood Stain",
				"General_Default-Procurement-Finishes-Wood-Look Flooring",
				"General_Default-Procurement-Finishes-Wood/Timber",
				"General_Default-Procurement-Furnishings",
				"General_Default-Procurement-Hardware",
				"General_Default-Procurement-HVAC",
				"General_Default-Procurement-Landscaping",
				"General_Default-Procurement-Lighting",
				"General_Default-Procurement-Masonry",
				"General_Default-Procurement-Millwork & Casework",
				"General_Default-Procurement-Mouldings",
				"General_Default-Procurement-Plumbing"
			],
			"__permissions": ["SettingsInstallerSupplierProcurement"]
		},
		"Default Suppliers": {
			"values": [
				"General_Default-Supplier-Appliances",
				"General_Default-Supplier_Contact-Appliances",
				"General_Default-Supplier-Building Materials",
				"General_Default-Supplier_Contact-Building Materials",
				"General_Default-Supplier-Concrete",
				"General_Default-Supplier_Contact-Concrete",
				"General_Default-Supplier-Conveying Equipment",
				"General_Default-Supplier_Contact-Conveying Equipment",
				"General_Default-Supplier-Doors & Windows",
				"General_Default-Supplier_Contact-Doors & Windows",
				"General_Default-Supplier-Electrical",
				"General_Default-Supplier_Contact-Electrical",
				"General_Default-Supplier-Equipment",
				"General_Default-Supplier_Contact-Equipment",
				"General_Default-Supplier-Finishes-Carpet",
				"General_Default-Supplier_Contact-Finishes-Carpet",
				"General_Default-Supplier-Finishes-Metal",
				"General_Default-Supplier_Contact-Finishes-Metal",
				"General_Default-Supplier-Finishes-Miscellaneous",
				"General_Default-Supplier_Contact-Finishes-Miscellaneous",
				"General_Default-Supplier-Finishes-Paint",
				"General_Default-Supplier_Contact-Finishes-Paint",
				"General_Default-Supplier-Finishes-Part",
				"General_Default-Supplier_Contact-Finishes-Part",
				"General_Default-Supplier-Finishes-Slab",
				"General_Default-Supplier_Contact-Finishes-Slab",
				"General_Default-Supplier-Finishes-Tile",
				"General_Default-Supplier_Contact-Finishes-Tile",
				"General_Default-Supplier-Finishes-Wall Covering",
				"General_Default-Supplier_Contact-Finishes-Wall Covering",
				"General_Default-Supplier-Finishes-Wood Stain",
				"General_Default-Supplier_Contact-Finishes-Wood Stain",
				"General_Default-Supplier-Finishes-Wood-Look Flooring",
				"General_Default-Supplier_Contact-Finishes-Wood-Look Flooring",
				"General_Default-Supplier-Finishes-Wood/Timber",
				"General_Default-Supplier_Contact-Finishes-Wood/Timber",
				"General_Default-Supplier-Furnishings",
				"General_Default-Supplier_Contact-Furnishings",
				"General_Default-Supplier-Hardware",
				"General_Default-Supplier_Contact-Hardware",
				"General_Default-Supplier-HVAC",
				"General_Default-Supplier_Contact-HVAC",
				"General_Default-Supplier-Landscaping",
				"General_Default-Supplier_Contact-Landscaping",
				"General_Default-Supplier-Lighting",
				"General_Default-Supplier_Contact-Lighting",
				"General_Default-Supplier-Masonry",
				"General_Default-Supplier_Contact-Masonry",
				"General_Default-Supplier-Millwork & Casework",
				"General_Default-Supplier_Contact-Millwork & Casework",
				"General_Default-Supplier-Mouldings",
				"General_Default-Supplier_Contact-Mouldings",
				"General_Default-Supplier-Plumbing",
				"General_Default-Supplier_Contact-Plumbing"
			],
			"__permissions": ["SettingsInstallerSupplierProcurement"]
		},
		"General": {
			"Default Division": {
				"values": ["General_Default-Division_Default-view"]
			}
		},
		"Project Edit Access": {
			"values": ["General_Project-Edit-Access_Access-Type"]
		},
		"Units & Increments": {
			"Estimates": {
				"Area Measuring Accuracy": {
					"values": ["Estimates_Area-Measuring-Accuracy-Ft"]
				},
				"Linear Measuring Accuracy": {
					"values": ["Estimates_Linear-Measuring-Accuracy-Ft"]
				},
				"__permissions": ["ConstructionSetsView"]
			},
			"Measurements": {
				"Ceiling Height": {
					"values": ["Measurements_Ceiling-Height-In"]
				},
				"Wall Thickness": {
					"values": ["Measurements_Wall-Thickness-In"]
				},
				"Base Category Height ": {
					"values": ["Measurements_Default-Height-Base-Category"]
				},
				"__permissions": ["ConstructionSetsView"]
			},
			"Nudge Increments": {
				"Book": {
					"values": ["Nudge-Increments_Book_Small_Nudge-Px", "Nudge-Increments_Book_Big_Nudge-Px"]
				}
			}
		}
	},
	"mySetting": {
		"Books": {
			"Page Settings": {
				"values": [
					"Books_Page-settings_Ruler-label",
					"Books_Page-settings_Show-ruler",
					"Books_Page-settings_Grids-label",
					"Books_Page-settings_Show-grid",
					"Books_Page-settings_View-grid",
					"Books_Page-settings_Snap-elements",
					"Books_Page-settings_Grid-size",
					"Books_Page-settings_Grid-color-label",
					"Books_Page-settings_Grid-color-label",
					"Books_Page-settings_Grid-color",
					"Books_Page-settings_Show-guide-label",
					"Books_Page-settings_Show-guide",
					"Books_Page-settings_Guide-color-label",
					"Books_Page-settings_Guide-color"
				]
			},
			"Size": {
				"values": ["Books_Size_Orientation-Label", "Books_Size_Orientation", "Books_Size_Default-size"]
			}
		},
		"General": {
			"Default Division": {
				"values": ["General_Default-Division_Default-view"]
			}
		},
		"Units & Increments": {
			"Estimates": {
				"Area Measuring Accuracy": {
					"values": ["Estimates_Area-Measuring-Accuracy-Ft"]
				},
				"Linear Measuring Accuracy": {
					"values": ["Estimates_Linear-Measuring-Accuracy-Ft"]
				},
				"__permissions": ["ConstructionSetsView"]
			},
			"Measurements": {
				"Ceiling Height": {
					"values": ["Measurements_Ceiling-Height-In"]
				},
				"Wall Thickness": {
					"values": ["Measurements_Wall-Thickness-In"]
				},
				"Base Category Height ": {
					"values": ["Measurements_Default-Height-Base-Category"]
				},
				"__permissions": ["ConstructionSetsView"]
			},
			"Nudge Increments": {
				"Book": {
					"values": ["Nudge-Increments_Book_Small_Nudge-Px", "Nudge-Increments_Book_Big_Nudge-Px"]
				}
			}
		}
	},
	"projectSetting": {
		"Books": {
			"Page Settings": {
				"values": [
					"Books_Page-settings_Ruler-label",
					"Books_Page-settings_Show-ruler",
					"Books_Page-settings_Grids-label",
					"Books_Page-settings_Show-grid",
					"Books_Page-settings_View-grid",
					"Books_Page-settings_Snap-elements",
					"Books_Page-settings_Grid-size",
					"Books_Page-settings_Grid-color-label",
					"Books_Page-settings_Grid-color-label",
					"Books_Page-settings_Grid-color",
					"Books_Page-settings_Show-guide-label",
					"Books_Page-settings_Show-guide",
					"Books_Page-settings_Guide-color-label",
					"Books_Page-settings_Guide-color"
				]
			},
			"Size": {
				"values": ["Books_Size_Orientation-Label", "Books_Size_Orientation", "Books_Size_Default-size"]
			}
		},
		"Deadlines": {
			"values": [
				"Project_Deadlines_Appliances",
				"Project_Deadlines_Building-Materials",
				"Project_Deadlines_Concrete",
				"Project_Deadlines_Conveying-Equipment",
				"Project_Deadlines_Doors-Windows",
				"Project_Deadlines_Electrical",
				"Project_Deadlines_Equipment",
				"Project_Deadlines_Carpet",
				"Project_Deadlines_Metal",
				"Project_Deadlines_Miscellaneous",
				"Project_Deadlines_Paint",
				"Project_Deadlines_Part",
				"Project_Deadlines_Slab",
				"Project_Deadlines_Tile",
				"Project_Deadlines_Wall-Covering",
				"Project_Deadlines_Wood-Stain",
				"Project_Deadlines_Wood-Look-Flooring",
				"Project_Deadlines_Wood-Timber",
				"Project_Deadlines_Furnishings",
				"Project_Deadlines_Hardware",
				"Project_Deadlines_HVAC",
				"Project_Deadlines_Landscaping",
				"Project_Deadlines_Lighting",
				"Project_Deadlines_Masonry",
				"Project_Deadlines_Millwork-Casework",
				"Project_Deadlines_Mouldings",
				"Project_Deadlines_Plumbing"
			],
			"__permissions": ["ProjectDeadline"]
		},
		"Default Installers": {
			"values": [
				"General_Default-Installer-Appliances",
				"General_Default-Installer_Contact-Appliances",
				"General_Default-Installer-Building Materials",
				"General_Default-Installer_Contact-Building Materials",
				"General_Default-Installer-Concrete",
				"General_Default-Installer_Contact-Concrete",
				"General_Default-Installer-Conveying Equipment",
				"General_Default-Installer_Contact-Conveying Equipment",
				"General_Default-Installer-Doors & Windows",
				"General_Default-Installer_Contact-Doors & Windows",
				"General_Default-Installer-Electrical",
				"General_Default-Installer_Contact-Electrical",
				"General_Default-Installer-Equipment",
				"General_Default-Installer_Contact-Equipment",
				"General_Default-Installer-Finishes-Carpet",
				"General_Default-Installer_Contact-Finishes-Carpet",
				"General_Default-Installer-Finishes-Metal",
				"General_Default-Installer_Contact-Finishes-Metal",
				"General_Default-Installer-Finishes-Miscellaneous",
				"General_Default-Installer_Contact-Finishes-Miscellaneous",
				"General_Default-Installer-Finishes-Paint",
				"General_Default-Installer_Contact-Finishes-Paint",
				"General_Default-Installer-Finishes-Part",
				"General_Default-Installer_Contact-Finishes-Part",
				"General_Default-Installer-Finishes-Slab",
				"General_Default-Installer_Contact-Finishes-Slab",
				"General_Default-Installer-Finishes-Tile",
				"General_Default-Installer_Contact-Finishes-Tile",
				"General_Default-Installer-Finishes-Wall Covering",
				"General_Default-Installer_Contact-Finishes-Wall Covering",
				"General_Default-Installer-Finishes-Wood Stain",
				"General_Default-Installer_Contact-Finishes-Wood Stain",
				"General_Default-Installer-Finishes-Wood-Look Flooring",
				"General_Default-Installer_Contact-Finishes-Wood-Look Flooring",
				"General_Default-Installer-Finishes-Wood/Timber",
				"General_Default-Installer_Contact-Finishes-Wood/Timber",
				"General_Default-Installer-Furnishings",
				"General_Default-Installer_Contact-Furnishings",
				"General_Default-Installer-Hardware",
				"General_Default-Installer_Contact-Hardware",
				"General_Default-Installer-HVAC",
				"General_Default-Installer_Contact-HVAC",
				"General_Default-Installer-Landscaping",
				"General_Default-Installer_Contact-Landscaping",
				"General_Default-Installer-Lighting",
				"General_Default-Installer_Contact-Lighting",
				"General_Default-Installer-Masonry",
				"General_Default-Installer_Contact-Masonry",
				"General_Default-Installer-Millwork & Casework",
				"General_Default-Installer_Contact-Millwork & Casework",
				"General_Default-Installer-Mouldings",
				"General_Default-Installer_Contact-Mouldings",
				"General_Default-Installer-Plumbing",
				"General_Default-Installer_Contact-Plumbing"
			],
			"__permissions": ["SettingsInstallerSupplierProcurement"]
		},
		"Default Procurement": {
			"values": [
				"General_Default-Procurement-Appliances",
				"General_Default-Procurement-Building Materials",
				"General_Default-Procurement-Concrete",
				"General_Default-Procurement-Conveying Equipment",
				"General_Default-Procurement-Doors & Windows",
				"General_Default-Procurement-Electrical",
				"General_Default-Procurement-Equipment",
				"General_Default-Procurement-Finishes-Carpet",
				"General_Default-Procurement-Finishes-Metal",
				"General_Default-Procurement-Finishes-Miscellaneous",
				"General_Default-Procurement-Finishes-Paint",
				"General_Default-Procurement-Finishes-Part",
				"General_Default-Procurement-Finishes-Slab",
				"General_Default-Procurement-Finishes-Tile",
				"General_Default-Procurement-Finishes-Wall Covering",
				"General_Default-Procurement-Finishes-Wood Stain",
				"General_Default-Procurement-Finishes-Wood-Look Flooring",
				"General_Default-Procurement-Finishes-Wood/Timber",
				"General_Default-Procurement-Furnishings",
				"General_Default-Procurement-Hardware",
				"General_Default-Procurement-HVAC",
				"General_Default-Procurement-Landscaping",
				"General_Default-Procurement-Lighting",
				"General_Default-Procurement-Masonry",
				"General_Default-Procurement-Millwork & Casework",
				"General_Default-Procurement-Mouldings",
				"General_Default-Procurement-Plumbing"
			],
			"__permissions": ["SettingsInstallerSupplierProcurement"]
		},
		"Default Suppliers": {
			"values": [
				"General_Default-Supplier-Appliances",
				"General_Default-Supplier_Contact-Appliances",
				"General_Default-Supplier-Building Materials",
				"General_Default-Supplier_Contact-Building Materials",
				"General_Default-Supplier-Concrete",
				"General_Default-Supplier_Contact-Concrete",
				"General_Default-Supplier-Conveying Equipment",
				"General_Default-Supplier_Contact-Conveying Equipment",
				"General_Default-Supplier-Doors & Windows",
				"General_Default-Supplier_Contact-Doors & Windows",
				"General_Default-Supplier-Electrical",
				"General_Default-Supplier_Contact-Electrical",
				"General_Default-Supplier-Equipment",
				"General_Default-Supplier_Contact-Equipment",
				"General_Default-Supplier-Finishes-Carpet",
				"General_Default-Supplier_Contact-Finishes-Carpet",
				"General_Default-Supplier-Finishes-Metal",
				"General_Default-Supplier_Contact-Finishes-Metal",
				"General_Default-Supplier-Finishes-Miscellaneous",
				"General_Default-Supplier_Contact-Finishes-Miscellaneous",
				"General_Default-Supplier-Finishes-Paint",
				"General_Default-Supplier_Contact-Finishes-Paint",
				"General_Default-Supplier-Finishes-Part",
				"General_Default-Supplier_Contact-Finishes-Part",
				"General_Default-Supplier-Finishes-Slab",
				"General_Default-Supplier_Contact-Finishes-Slab",
				"General_Default-Supplier-Finishes-Tile",
				"General_Default-Supplier_Contact-Finishes-Tile",
				"General_Default-Supplier-Finishes-Wall Covering",
				"General_Default-Supplier_Contact-Finishes-Wall Covering",
				"General_Default-Supplier-Finishes-Wood Stain",
				"General_Default-Supplier_Contact-Finishes-Wood Stain",
				"General_Default-Supplier-Finishes-Wood-Look Flooring",
				"General_Default-Supplier_Contact-Finishes-Wood-Look Flooring",
				"General_Default-Supplier-Finishes-Wood/Timber",
				"General_Default-Supplier_Contact-Finishes-Wood/Timber",
				"General_Default-Supplier-Furnishings",
				"General_Default-Supplier_Contact-Furnishings",
				"General_Default-Supplier-Hardware",
				"General_Default-Supplier_Contact-Hardware",
				"General_Default-Supplier-HVAC",
				"General_Default-Supplier_Contact-HVAC",
				"General_Default-Supplier-Landscaping",
				"General_Default-Supplier_Contact-Landscaping",
				"General_Default-Supplier-Lighting",
				"General_Default-Supplier_Contact-Lighting",
				"General_Default-Supplier-Masonry",
				"General_Default-Supplier_Contact-Masonry",
				"General_Default-Supplier-Millwork & Casework",
				"General_Default-Supplier_Contact-Millwork & Casework",
				"General_Default-Supplier-Mouldings",
				"General_Default-Supplier_Contact-Mouldings",
				"General_Default-Supplier-Plumbing",
				"General_Default-Supplier_Contact-Plumbing"
			],
			"__permissions": ["SettingsInstallerSupplierProcurement"]
		},
		"General": {
			"Default Division": {
				"values": ["General_Default-Division_Default-view"]
			}
		},
		"Units & Increments": {
			"Estimates": {
				"Area Measuring Accuracy": {
					"values": ["Estimates_Area-Measuring-Accuracy-Ft"]
				},
				"Linear Measuring Accuracy": {
					"values": ["Estimates_Linear-Measuring-Accuracy-Ft"]
				},
				"__permissions": ["ConstructionSetsView"]
			},
			"Measurements": {
				"Ceiling Height": {
					"values": ["Measurements_Ceiling-Height-In"]
				},
				"Wall Thickness": {
					"values": ["Measurements_Wall-Thickness-In"]
				},
				"Base Category Height ": {
					"values": ["Measurements_Default-Height-Base-Category"]
				},
				"__permissions": ["ConstructionSetsView"]
			},
			"Nudge Increments": {
				"Book": {
					"values": ["Nudge-Increments_Book_Small_Nudge-Px", "Nudge-Increments_Book_Big_Nudge-Px"]
				}
			}
		}
	}
}
